import { render, staticRenderFns } from "./TermsBahasa.vue?vue&type=template&id=0d940727"
import script from "./TermsBahasa.vue?vue&type=script&lang=js"
export * from "./TermsBahasa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports